import { v4 as generateUuid } from 'uuid';

const Id = {
  generate () {
    return generateUuid();
  }
};

export default Id;
